import { SectionText } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import joinImage from './assets/join.png';
import * as Styled from './styled';
import type { JoinTeamSectionProps } from './types';

export * from './types';

export const JoinTeamSection: FC<JoinTeamSectionProps> = (props) => {
  const { link, ...rest } = props;

  const { translate } = useTranslation();

  return (
    <Styled.Wrapper {...rest}>
      <Styled.BackgroundCard>
        <Styled.BackgroundImage src={joinImage} alt="join image" />
      </Styled.BackgroundCard>
      <Styled.ContentCard>
        <Styled.ContentCardTitle>{translate('team.join.title')}</Styled.ContentCardTitle>
        <SectionText>{translate('team.join.subtitle')}</SectionText>
        <Styled.ContentCardButton shrink color="blue" size="large" link={link}>
          {translate('common.buttons.joinTheTeam')}
        </Styled.ContentCardButton>
      </Styled.ContentCard>
    </Styled.Wrapper>
  );
};
